module.exports = __webpack_public_path__ + "img/08.bbd03f8b.svg";